import React, { useEffect, useState } from "react";
import "../../../styles/desktop/userconfig.css";

import Alterar from "./Alterar/alterar";
import Adicionar from "./Adicionar/adicionar";
import Deletar from "./Deletar/deletar";
import Responsaveis from "./Responsaveis/responsaveis";

import { checkAdmin } from "../../../API/server/adminVerify";
import UserConfigIcon from "../../../assets/svg/userConfig";
import UserAddIcon from "../../../assets/svg/userAddIcon";
import UserDelIcon from "../../../assets/svg/userDelIcon";
import UserManagerIcon from "../../../assets/svg/userManagerIcon";

export default function UserConfig({ onBack }) {
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showAlterar, setShowAlterar] = useState(false);
    const [showAdicionar, setShowAdicionar] = useState(false);
    const [showDeletar, setShowDeletar] = useState(false);
    const [showGerenciar, setShowGerenciar] = useState(false); // Estado para Gerenciar
    const [isBackVisible, setIsBackVisible] = useState(true);
    const [animationClass, setAnimationClass] = useState("");

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (user) {
            checkAdmin(user.user)
                .then((isAdmin) => {
                    console.log("Resposta do servidor - isAdmin:", isAdmin);
                    setIsAdmin(isAdmin);
                })
                .finally(() => setIsLoading(false));
        } else {
            setIsAdmin(false);
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsBackVisible(true);
        }, 500); // Meio segundo (500ms)
    
        return () => clearTimeout(timer); // Limpa o timeout caso o componente seja desmontado
    }, []);

    const handleShowAlterar = () => {
        setIsBackVisible(false);
        setAnimationClass("slide-enter");
        setShowAlterar(true);
    };

    const handleHideAlterar = () => {
        setAnimationClass("slide-exit");
        setTimeout(() => {
            setShowAlterar(false);
            setIsBackVisible(true);
        }, 500);
    };

    const handleShowAdicionar = () => {
        setIsBackVisible(false);
        setAnimationClass("slide-enter");
        setShowAdicionar(true);
    };

    const handleHideAdicionar = () => {
        setAnimationClass("slide-exit");
        setTimeout(() => {
            setShowAdicionar(false);
            setIsBackVisible(true);
        }, 500);
    };

    const handleShowDeletar = () => {
        setIsBackVisible(false);
        setAnimationClass("slide-enter");
        setShowDeletar(true);
    };

    const handleHideDeletar = () => {
        setAnimationClass("slide-exit");
        setTimeout(() => {
            setShowDeletar(false);
            setIsBackVisible(true);
        }, 500);
    };

    const handleShowGerenciar = () => {
        setIsBackVisible(false);
        setAnimationClass("slide-enter");
        setShowGerenciar(true);
    };

    const handleHideGerenciar = () => {
        setAnimationClass("slide-exit");
        setTimeout(() => {
            setShowGerenciar(false);
            setIsBackVisible(true);
        }, 500);
    };

    if (isLoading) {
        return null;
    }

    return (
        <div className="contentUserConfig">
            {isBackVisible && (
                <div className="user-back-button fade-in" onClick={onBack}>
                    Voltar
                </div>
            )}

            {showAlterar ? (
                <div className={`alterar-container ${animationClass}`}>
                    <Alterar onBack={handleHideAlterar} isAdmin={isAdmin} />
                </div>
            ) : showAdicionar ? (
                <div className={`adicionar-container ${animationClass}`}>
                    <Adicionar onBack={handleHideAdicionar} isAdmin={isAdmin} />
                </div>
            ) : showDeletar ? (
                <div className={`deletar-container ${animationClass}`}>
                    <Deletar onBack={handleHideDeletar} isAdmin={isAdmin} />
                </div>
            ) : showGerenciar ? (
                <div className={`gerenciar-container ${animationClass}`}>
                    <Responsaveis onBack={handleHideGerenciar} isAdmin={isAdmin} />
                </div>
            ) : (
                <>
                    <div
                        className="optionUserConfig animate-item"
                        style={{ animationDelay: "0s" }}
                        onClick={handleShowAlterar}
                    >
                        <div className="iconUserConfig">
                            <UserConfigIcon width={75} height={75} className={"iconeUserConfig"} />
                        </div>
                        <div className="textUserConfig">
                            <p>Alterar Dados de usuário</p>
                        </div>
                    </div>

                    <div
                        className={`optionUserConfig animate-item ${!isAdmin ? "disabledOption" : ""}`}
                        style={{ animationDelay: "0.2s" }}
                        onClick={isAdmin ? handleShowAdicionar : undefined}
                    >
                        <div className="iconUserConfig">
                            <UserAddIcon width={75} height={75} className={"iconeUserConfig"} />
                            {!isAdmin && <span className="lockIcon">🔒</span>}
                        </div>
                        <div className="textUserConfig">
                            <p>Adicionar usuário</p>
                        </div>
                    </div>

                    <div
                        className={`optionUserConfig animate-item ${!isAdmin ? "disabledOption" : ""}`}
                        style={{ animationDelay: "0.4s" }}
                        onClick={isAdmin ? handleShowDeletar : undefined}
                    >
                        <div className="iconUserConfig">
                            <UserDelIcon width={75} height={75} className={"iconeUserConfig"} />
                            {!isAdmin && <span className="lockIcon">🔒</span>}
                        </div>
                        <div className="textUserConfig">
                            <p>Remover usuário</p>
                        </div>
                    </div>

                    <div
                        className={`optionUserConfig animate-item ${!isAdmin ? "disabledOption" : ""}`}
                        style={{ animationDelay: "0.6s" }}
                        onClick={isAdmin ? handleShowGerenciar : undefined}
                    >
                        <div className="iconUserConfig">
                            <UserManagerIcon width={75} height={75} className={"iconeUserConfig"}/>
                            {!isAdmin && <span className="lockIcon">🔒</span>}
                        </div>
                        <div className="textUserConfig">
                            <p>Gerenciar Responsáveis</p>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
